"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUniqueIdCookie = void 0;

var _nanoid = _interopRequireDefault(require("nanoid"));

var _universalCookie = _interopRequireDefault(require("universal-cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getUniqueIdCookie = function getUniqueIdCookie() {
  var cookies = new _universalCookie["default"]();
  var uniqueId = getCookie(cookies);

  if (!uniqueId) {
    uniqueId = createCookie(cookies);
  }

  return uniqueId;
};

exports.getUniqueIdCookie = getUniqueIdCookie;

var getCookie = function getCookie(cookies) {
  var uniqueId = cookies.get("ftvOption%3AuniqueId");
  return uniqueId;
};

var createCookie = function createCookie(cookies) {
  var uniqueId = (0, _nanoid["default"])(18);
  cookies.set("ftvOption%3AuniqueId", uniqueId, {
    path: "/"
  });
  return uniqueId;
};